import { z } from 'zod';

import { OrganizationCadastralReadFieldsSchema } from './organization-cadastral.schemas.js';

export const OrganizationIdParamsSchema = z.object({
  organizationId: z.uuid(),
});

export type OrganizationIdParams = z.infer<typeof OrganizationIdParamsSchema>;

export const OrganizationPlaceSummarySchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  documentNumber: z.string(),
  active: z.boolean(),
  isCentralDistribution: z.boolean(),
});

export const GetOrganizationResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  documentNumber: z.string(),
  personKind: z.enum(['INDIVIDUAL', 'COMPANY']),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  places: z.array(OrganizationPlaceSummarySchema),
  ...OrganizationCadastralReadFieldsSchema.shape,
});

export type GetOrganizationResponse = z.infer<typeof GetOrganizationResponseSchema>;

export const DeactivateOrganizationResponseSchema = z.object({
  organizationId: z.uuid(),
  active: z.literal(false),
});

export type DeactivateOrganizationResponse = z.infer<typeof DeactivateOrganizationResponseSchema>;
